/**
 * usePrintContext Hook
 *
 * Provides access to the current PrintContext from the productSelectionStore.
 * This is the primary way for components to access print area information.
 *
 * @see types/printContext.ts - PrintContext interface
 * @see stores/productSelectionStore.ts - Where the context is stored
 */

import { useProductSelectionStore } from '@/stores';
import type { PrintContext } from '@/types/printContext';

/**
 * The PrintContext of the active template: its rectangle, the area's mm
 * and the template's Pixel Scale. Null while no configured template is
 * shown; there is no default area to fall back on (R11).
 *
 * @example
 * ```tsx
 * const printContext = usePrintContext();
 * if (printContext) console.log(`${printContext.widthCm} x ${printContext.heightCm} cm`);
 * ```
 */
export function usePrintContext(): PrintContext | null {
  return useProductSelectionStore((state) => state.activePrintContext);
}
